import { useState } from 'react';
import type { Lang } from '@/data/categories';
import { homeContent } from '@/data/home';
import { uiContent } from '@/data/ui';
import { MAIN_SITE_URL } from '@/data/categories';

export default function FaqSection({ lang }: { lang: Lang }) {
  const c = homeContent[lang];
  const t = uiContent[lang];
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <>
      <section id="faq" className="mx-auto max-w-4xl px-4 md:px-6 py-14 md:py-20">
        <h2 className="text-center text-2xl font-bold text-foreground-950 md:text-3xl">{c.faq.h2}</h2>
        <div className="mt-8 space-y-3">
          {c.faq.items.map((item, i) => {
            const open = openIndex === i;
            return (
              <div key={i} className="rounded-lg border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="text-sm font-semibold text-foreground-900 md:text-base">{item.q}</span>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition ${open ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-primary-500">
        <div className="mx-auto max-w-4xl px-4 md:px-6 py-14 md:py-20 text-center">
          <h2 className="text-2xl font-bold text-background-50 md:text-4xl">{c.final.h2}</h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-background-100/90 md:text-base">{c.final.copy}</p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition hover:bg-background-100 md:text-base"
            >
              {c.final.cta}
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-background-50/10 md:text-base"
            >
              {c.final.secondary}
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}